"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as c } from "react";
import l from "../components/Icon/SvgIcon.js";
const t = (e) => /* @__PURE__ */ o(
  l,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.2 10.847 4.726 2.067a2.25 2.25 0 0 1 1.16 1.16l2.067 4.726 5.552-13.505zm4.226 3.211L4.16 11.756c-.81-.354-.796-1.506.02-1.841L18.784 3.91c.822-.338 1.643.484 1.305 1.305L14.086 19.82c-.336.816-1.488.83-1.842.02l-2.303-5.265a1 1 0 0 0-.516-.516Z",
        clipRule: "evenodd"
      }
    )
  }
), r = c(t);
export {
  r as LocationAccess,
  r as default
};
